import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import Cookies from 'quasar/src/plugins/Cookies.js';;
import { axiosInstance } from "./axios";
export default
/*#__PURE__*/
(function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref2) {
    var store, ssrContext, cookies;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = _ref2.store, ssrContext = _ref2.ssrContext;
            cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies;

            if (cookies.has('auth_token')) {
              store.commit('auth/isAuthenticated', true);
              axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookies.get('auth_token');
            } else {
              cookies.remove('auth_token');
              cookies.remove('auth_token_life');
              cookies.remove('auth_token_type');
              cookies.remove('refresh_token');
              cookies.remove('refresh_token_life');
              store.commit('auth/clean');
            }

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();